export default {
      id: "information-usage",
      viewBox: "0 0 330 330",
      url: __webpack_public_path__ + "img/svg.c2d72070.svg#information",
      toString: function () {
        return this.url;
      }
    }